import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export const INTEL_API = process.env.REACT_APP_BACKEND_URL + "/api/admin/intelligence";

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : d?.message || e.message;
};

export const OutreachSendButton = ({ action, onDone }) => {
  const [pending, setPending] = useState(null);
  const [busy, setBusy] = useState(false);
  const id = action.action_id;
  const disabled = action.approval_status !== "APPROVED_FOR_EXTERNAL_ACTION" || ["SENT", "MOCKED"].includes(action.delivery?.status);

  const request = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${INTEL_API}/outreach-actions/${id}/send-request`);
      setPending(r.data);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const confirm = async () => {
    try {
      const r = await axios.post(`${INTEL_API}/outreach-actions/${id}/send`, { confirm: true, confirmation_token: pending.confirmation_token });
      toast.success(`Envoi : ${r.data.delivery.status}`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setPending(null); }
  };

  return (
    <>
      <Button size="sm" variant="outline" disabled={disabled || busy} onClick={request} data-testid={`intel-outreach-send-btn-${id}`}>Envoyer…</Button>
      <AlertDialog open={!!pending} onOpenChange={(o) => !o && setPending(null)}>
        <AlertDialogContent data-testid="intel-outreach-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmer l'envoi</AlertDialogTitle>
            <AlertDialogDescription>
              Destinataire : <strong>{pending?.recipient}</strong><br />Objet : {pending?.subject}<br />
              Aucun envoi n'a lieu sans cette confirmation explicite.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="intel-outreach-confirm-cancel">Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={confirm} data-testid="intel-outreach-confirm-send">Confirmer l'envoi</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
